export default "__VITE_ASSET__AvNTwOHW__"